// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1h9yt","amount":"Amount_amount__21NNw","tip":"Amount_tip__2UG4z","tipHeader":"Amount_tipHeader__3e-6A","tipsWrap":"Amount_tipsWrap__3yLH4"};